import { Route } from "@solidjs/router";
import { ROUTES } from "../const";
import { ShowSchedule } from "../views";
import { Ctrl } from ":mods";

export function StudentRoutes(props: Ctrl.Routes.model.StudentView) {
  return (
    <>
      <Route path={ROUTES.foundation()} element={<ShowSchedule {...props} />} />
    </>
  );
}
